import { render, staticRenderFns } from "./client-signup-login.vue?vue&type=template&id=9684716a"
import script from "./client-signup-login.vue?vue&type=script&lang=ts"
export * from "./client-signup-login.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9684716a')) {
      api.createRecord('9684716a', component.options)
    } else {
      api.reload('9684716a', component.options)
    }
    module.hot.accept("./client-signup-login.vue?vue&type=template&id=9684716a", function () {
      api.rerender('9684716a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/client-signup-login.vue"
export default component.exports